<template>
  <div class="index" >
    <div class="banner">
      <div class="banner-con">
        <tab @tab="bannerTab" ref="bannerTab">
          <div slot="tab-point" class="point">
            <span class="point-item "></span>
            <span class="point-item "></span>
            <span class="point-item "></span>
          </div>
          <div slot="tab-content" class="content">
              <div class="content-item">
                <transition name="fade">
                  <img src="~../assets/images/banner-chahua1.png" alt="" class="banner-img" v-show="bannerActive == 0">
                </transition>
                <div class="banner-info">
                  <div class="title" :key="0">小程序&nbsp;大商机</div>
                  <div class="small" :key="1">与你共掘千亿市场，共享微信10亿月活</div>
                  <div class="s-small" :key="2">MINI PROGRAM<br>BIG BUSINESS OPPORTUNITIES</div>
                </div>
              </div>


            <!--2-->
            <div class="content-item">
              <transition name="fade">
                <img src="~../assets/images/banner-chahua2.png" alt="" class="banner-img no-left" v-show="bannerActive == 1">
              </transition>
              <div class="banner-info" >
                <div class="title">全球代理火热招募中</div>
                <div class="small">掘金4000+万家企业，共享亿万红利</div>
                <div class="s-small">The global agent in recruiting </div>
                <button class="btn btn-more" @click="$router.push('invest')">了解详情</button>
              </div>
            </div>
            <!--3-->
            <div class="content-item">
              <transition name="fade">
                <img src="~../assets/images/banner-chahua3.png" alt="" class="banner-img no-left" v-show="bannerActive == 2">
              </transition>
              <div class="banner-info">
                <div class="title">全球代理火热招募中</div>
                <div class="small">与其谈小程序风口，不如多给客户带来一些订单更实在</div>
                <div class="s-small">Brings to the customer order some more</div>
                <button class="btn btn-more" @click="$router.push('invest')">了解详情</button>
              </div>
            </div>
          </div>
        </tab>
      </div>
    </div>
    <!--01-->
    <index-part-one id="index-part-one" ref="partOne"></index-part-one>
    <!--02-->
    <index-part-two></index-part-two>
    <!--03-->
    <index-part-three></index-part-three>
    <!--04-->
    <div class="bg-wrapper">
      <div class="bg-wrap"></div>
      <index-part-four></index-part-four>
    </div>
    <!--05-->
    <index-part-five></index-part-five>
    <!--06-->
    <index-part-six></index-part-six>
  </div>
</template>

<script type="text/ecmascript-6">
import Tab from '../components/common/tab'
import IndexPartOne from '../components/business/IndexPartOne'
import IndexPartTwo from '../components/business/IndexPartTwo'
import IndexPartThree from '../components/business/IndexPartThree'
import IndexPartFour from '../components/business/IndexPartFour'
import IndexPartFive from '../components/business/IndexpartFive'
import IndexPartSix from '../components/business/IndexPartSix'
import animate from '../common/animate'
import scrollMixin from '../common/scrollMixin'
export default {
  mixins: [scrollMixin],
  data() {
    return {
      bannerActive: 0
    }
  },
  methods: {
    // banner 点击point 切换事件
    bannerTab(index){
      this.bannerActive = index
      clearTimeout(this.$bannerTimer)
      this.changeBanner()
    },
    // 开启定时切换
    changeBanner(){
      this.$bannerTimer = setTimeout(() => {
        this.$refs.bannerTab.tab((this.bannerActive + 1) % 3)
      },8000)
    }
  },
  mounted(){
    this.changeBanner()
  },
  beforeDestroy () {
    clearTimeout(this.$bannerTimer)
  },
  components: {
    Tab,
    IndexPartOne,
    IndexPartTwo,
    IndexPartThree,
    IndexPartFour,
    IndexPartFive,
    IndexPartSix
  }
}
</script>

<style scoped lang="scss">
@import "../common/common.scss";
$banner-height: 750px;
.index{
  overflow-x:hidden;
  .banner{
    height: $banner-height;
    min-width: $min-width;
    background-image: url("../assets/images/banner-bg.png");
    @include bg-center;
    background-size: 1920px 750px;
    .banner-con{
      max-width: $max-width;
      min-width: $min-width;
      margin: 0 auto;
      position: relative;
      height: 100%;
      /*banner 指示点*/
      .point{
        position: absolute;
        right: 120px;
        bottom: 35px;
        .point-item{
          display: inline-block;
          height: 10px;
          width: 10px;
          background-color:#d5d9d5;
          border-radius: 50%;
          margin-right: 14px;
          cursor: pointer;
          &.active{
            background-color: $theme-color;
            width: 26px;
            border-radius: 10px;
            transition: all 0.2s;
          }
        }
      }
      /* tab 内容区*/
      .content{
        height: 100%;
        .banner-img{
          position: absolute;
          @include vertical-center;
          left: -145px;
          &.no-left{
            left: 20px;

          }
          /*动画*/
          &.fade-enter-active, &.fade-leave-active{
            transition: all .8s;
          }
          &.fade-enter, &.fade-leave-to{
            top: 60%;
            opacity:0;
          }
        }
        .banner-info{
          position: absolute;
          left: 730px;
          top:194px;
          line-height: 1.0;
          color: #fff;
          @media screen and (max-width:$max-width) and (min-width:$min-width){
            right: 50px;
            left: auto;
            width: 684px;

          }
          .title{
            font-size: 76px;
            font-weight: bold;
            animation: slide-in0 1s ;
          }
          .small{
            font-size: 36px;
            margin-top: 28px;
            animation: slide-in1 1s ;
            word-break: keep-all;
            white-space: nowrap;
            @media screen and (max-width:$max-width) and (min-width: $min-width) {
              line-height: 1.4;
              word-break: normal;
              white-space: normal;
            }
          }
          .s-small{
            font-size: 16px;
            margin-top: 44px;
            opacity: 0.6;
            line-height: 1.6;
            letter-spacing: 3px;
            animation: slide-in2 1s;
            transition: opacity .2s;
          }
          .btn-more{
            padding: 0 58px;
            line-height: 48px;
            font-size: 18px;
            color: $theme-color;
            border-radius: 4px;
            margin-top: 30px;
            background-color:#fff;
            animation: slide-in3 1s ;
          }
        }
      }
    }
  }
  .bg-wrapper{
    width: 100%;
    position: relative;
    .bg-wrap{
      position: absolute;
      width: 1920px;
      height: 2459px;
      @include horizontal-center;
      top: -160px;
      background-image: url("../assets/images/index4bg.png");
    }
  }
}

@include slide-in(0);
@include slide-in(1,20);
@include slide-in(2,40);
@include slide-in(3,60);
</style>



// WEBPACK FOOTER //
// src/apps/zcx/page/Index.vue